import { render, staticRenderFns } from "./ArticleCreateBatch.vue?vue&type=template&id=3f7340df&"
import script from "./ArticleCreateBatch.vue?vue&type=script&lang=js&"
export * from "./ArticleCreateBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports